module.exports = __webpack_public_path__ + "static/media/report.2298fc48.png";